import React from "react";
import Helmet from "react-helmet";
import Layout from "../components/layout";
// import Lightbox from 'react-images'

import Gallery from "../components/Gallery";

import full01 from "../assets/images/fulls/sportsconnect.jpg";
import full02 from "../assets/images/fulls/sportsconnect_local-clubs-and-leagues.jpg";
import full03 from "../assets/images/fulls/sportsconnect_about-us.jpg";


import thumb01 from "../assets/images/fulls/sportsconnect.jpg";
import thumb02 from "../assets/images/fulls/sportsconnect_local-clubs-and-leagues.jpg";
import thumb03 from "../assets/images/fulls/sportsconnect_about-us.jpg";



const DEFAULT_IMAGES = [
  {
    id: "1",
    source: full01,
    thumbnail: thumb01,
  },
  {
    id: "2",
    source: full02,
    thumbnail: thumb02,
  },
  {
    id: "3",
    source: full03,
    thumbnail: thumb03,
  },
];

const SportsConnect = () => (
  <Layout>
           <Helmet>
          <title>Andy Miller - Sports Connect Website</title>
        </Helmet>
        <div id="main">
    <h1>Sports Connect Website</h1>
    <p>I designed and developed the marketing website for Sports Connect, a club league management system. This website was designed and developed in under 3 weeks, with a quick turnaround time being a necessity. I was able to succeed in the time allotted without any problems due to owning the whole process, and being able to self-QA my work since I helmed both sides of the project.</p>

    <a href="https://sportsconnect.com" class="button marginb">
      Live Website
    </a>
    <Gallery
              images={DEFAULT_IMAGES.map(
                ({ id, source, thumbnail, caption, description }) => ({
                  source,
                  thumbnail,
                })
              )}
            />
    </div>
  </Layout>
);

export default SportsConnect;
